export default __webpack_public_path__ + "static/Plots0024-219d64073ecb499a46402fbd19bc7e91.jpg";